export const ACCENT_STORAGE_KEY = 'muahang_accent_id'

export const DEFAULT_ACCENT_ID = 'blue'

export type AccentPreset = {
  id: string
  /** Ô màu trên popover */
  main: string
}

/** 9 chủ đề — cùng bố cục grid tham chiếu KiotViet. */
export const ACCENT_PRESETS: AccentPreset[] = [
  { id: 'blue', main: '#0070f4' },
  { id: 'navy', main: '#334155' },
  { id: 'green', main: '#15803d' },
  { id: 'purple', main: '#7c3aed' },
  { id: 'red', main: '#dc2626' },
  { id: 'slate', main: '#64748b' },
  { id: 'teal', main: '#0d9488' },
  { id: 'orange', main: '#ea580c' },
  { id: 'pink', main: '#db2777' },
]

export function resolveAccentMain(accentId: string): string {
  const hit = ACCENT_PRESETS.find((p) => p.id === accentId)
  return hit?.main ?? ACCENT_PRESETS[0].main
}
